import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '../../ReactQuery';
import { get } from '../../redux/api';

export type FinishedTrialResponse = {
  createdAt: Date;
  id: number;
  organizationId: number;
  submittedAt: Date;
};

const getQueryKey = (): QueryKey => ['finished-trials'];

const getFinishedTrial = () => get<FinishedTrialResponse | null>('/api/finished-trials');

/**
 * Hook used to get the finished trial for the organization, if exists.
 */
export function useGetFinishedTrial(shouldFetch: boolean) {
  return useQuery({
    enabled: shouldFetch,
    queryKey: getQueryKey(),
    queryFn: getFinishedTrial,
  });
}
